<template>
    <div>
        <EventMenu :event_id="id" v-if="type != 'quotation' && type != 'meeting'"></EventMenu>
        <MeetingMenu :meeting_id="id" v-if="type == 'meeting'"></MeetingMenu>
        <QuotationMenu :quotation_id="id" v-if="type == 'quotation'"></QuotationMenu>
    </div>
</template>

<script>
    import EventMenu from './EventMenu'
    import MeetingMenu from './MeetingMenu'
    import QuotationMenu from './QuotationMenu'
    export default {
        name: "EventMiddleScreen",
        data(){
            return {
                type:'',
                id:''
            }
        },
        components:{
            EventMenu,
            MeetingMenu,
            QuotationMenu
        },
        beforeMount(){
            if(typeof this.$router.currentRoute.params.type !=='undefined' && this.$router.currentRoute.params.type != '' && typeof this.$router.currentRoute.params.id !=='undefined' && this.$router.currentRoute.params.id != ''){
                this.type = this.$router.currentRoute.params.type;
                this.id = this.$router.currentRoute.params.id;
            }else{
                this.$router.push('/calendar');
            }
        }
    }
</script>